/**
 * Add CSRF token to request
 */
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

/**
 * Redirect to login page if session ends
 */
$(document).ajaxError(function(event, xhr) {
    if (xhr.status === 401) {
        window.location.reload();
    }
});

/**
 * Reload current page if token expired (happen at the ajax request)
 */
$(document).ajaxError(function(event, xhr) {
    if (xhr.status === 419) {
        window.location.reload();
    }
});
